<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Horisontellt kort
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Två varianter: kategori-kort (thumbnail + text + pil) och verktygskort
      (emojiruta + badge + text + pil).
    </p>

    <PreviewFull label="Kategorikort">
      <div
        class="flex items-center gap-4 p-4 bg-white rounded-2xl w-full"
        style="border: 1px solid #eceef0"
      >
        <!-- Thumbnail -->
        <div
          class="w-16 h-16 rounded-xl flex-shrink-0"
          style="background: linear-gradient(135deg, #d1faf5, #14b8a6)"
        />
        <!-- Text -->
        <div class="flex-1 min-w-0">
          <h4
            class="font-[Poppins] font-bold text-[15px] text-[#191c1e] m-0 mb-0.5"
          >
            Bröd & Bakverk
          </h4>
          <p
            class="font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] m-0 line-clamp-2"
          >
            Recept på surdeg, jästbröd, bullar och allt däremellan
          </p>
        </div>
        <ArrowRight :size="18" color="#a0b0ae" class="flex-shrink-0" />
      </div>
    </PreviewFull>

    <PreviewFull label="Verktygskort">
      <div
        class="flex items-center gap-4 p-4 bg-white rounded-2xl w-full"
        style="border: 1px solid #eceef0"
      >
        <!-- Emoji icon -->
        <div
          class="w-14 h-14 rounded-xl bg-teal-50 flex items-center justify-center flex-shrink-0 text-2xl"
        >
          🧮
        </div>
        <!-- Text -->
        <div class="flex-1 min-w-0">
          <div class="mb-1">
            <span
              class="px-2 py-0.5 rounded-full font-[Poppins] font-bold text-[10px] text-teal-500 tracking-[0.5px] uppercase"
              style="background: rgba(20, 184, 166, 0.1)"
              >Kalkylator</span
            >
          </div>
          <h4
            class="font-[Poppins] font-bold text-[15px] text-[#191c1e] m-0 mb-0.5"
          >
            Degkalkylator
          </h4>
          <p
            class="font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] m-0 line-clamp-2"
          >
            Beräkna ingredienser med baker's percentage
          </p>
        </div>
        <ArrowRight :size="18" color="#a0b0ae" class="flex-shrink-0" />
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ArrowRight } from "lucide-vue-next";
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex items-center gap-4 p-4 bg-white rounded-2xl" style="border: 1px solid #eceef0">
  <div class="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
    <img src="..." class="w-full h-full object-cover" />
  </div>
  <div class="flex-1 min-w-0">
    <h4 class="font-[Poppins] font-bold text-[15px] text-[#191c1e] m-0 mb-0.5">Titel</h4>
    <p class="font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] m-0 line-clamp-2">Beskrivning</p>
  </div>
  <ArrowRight :size="18" color="#a0b0ae" class="flex-shrink-0" />
</div>`;
const cssCode = `/* Kort-container */
border: 1px solid #eceef0;
border-radius: 16px;  /* rounded-2xl */
padding: 16px;

/* Miniatyrbild */
width: 64px;          /* w-16 */
height: 64px;         /* h-16 */
border-radius: 12px;  /* rounded-xl */

/* Rubrik */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 15px;
color: #191c1e;

/* Beskrivning */
font-family: 'Plus Jakarta Sans', sans-serif;
font-size: 13px;
color: #6c7a77;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
